module.exports = __webpack_public_path__ + "static/media/arrow-brown.f41a31b4.svg";